import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { orderActions } from "../../../../../store/orders-slice"
import InfoIcon from "../../../../InfoIcon"

const Resort = (props) => {
    const { type } = props

    const { resort } = useFilter()
    let filteredorders = useSelector((state) => state.order.filteredOrders)
    let orders=useSelector(state=>state.order.orders)

    let dispatch = useDispatch()


    return <Fragment>
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowUp} onClick={() => {

            dispatch(orderActions.setFilteredItems(resort(filteredorders??orders, type, 'ASC')))
        }} />
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowDown} onClick={() => {
            dispatch(orderActions.setFilteredItems(resort(filteredorders??orders, type, 'DESC')))
        }} />
    </Fragment>
}

export default Resort